import React from "react";
//prettier-ignore
//
export default function UploadIcon() {
    return (
        <svg onClick={(e)=>{
            e.preventDefault();
            const el=document.getElementById("image-upload")
            el.click();
            
        }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 17V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V17" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 6L12 2L8 6" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 2V16" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
